module.exports = __webpack_public_path__ + "static/media/portfolio1 (2).864b3037.jpeg";